import {FlagProps} from 'platform/components';
import {match} from 'ts-pattern';

import {always, isNil} from 'ramda';

import {RentalOrderResponseBody} from '@dms/api/rental';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const getRentToFlags = (rentalOrder: RentalOrderResponseBody | Nullish) => {
  if (isNil(rentalOrder)) {
    return undefined;
  }

  const stateFlag = match<RentalOrderResponseBody['state'], FlagProps>(rentalOrder?.state)
    .with(
      'draft',
      'reserved',
      'rented',
      always({
        colorScheme: 'neutral',
        label: i18n.t('page.rentalOrder.labels.scheduled'),
      })
    )
    .with(
      'canceled',
      always({
        colorScheme: 'red',
        label: i18n.t('page.rentalOrder.labels.cancelled'),
      })
    )
    .otherwise(
      always({
        label: i18n.t('page.rentalOrder.labels.returned'),
        colorScheme: 'purple',
      })
    );

  return [stateFlag];
};
